import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import URL from '../../constants/urls'
import { errorMessage } from '../../constants/errorMessage'
import { Circles } from 'react-loader-spinner'

const CardConnectTokenizer = (props) => {
  const { setToken, faciltyPaymentDetails, setIframeErrorMessage, tokenRef} = props
  const [iframeLoaded, setIframeLoaded] = useState(false)

  useEffect(() => {
    const handleMessage = (event) => {
      try {
        let data
        // Handle different data types
        if (typeof event.data === 'string') {
          try {
            data = JSON.parse(event.data)
          } catch (jsonError) {
            console.error('JSON parse error:', jsonError)
            // If it's a string but not valid JSON, treat it as a token
            if (event.data && event.data !== '[object Object]') {
              data = { message: event.data }
            } else {
              throw new Error('Invalid data format received')
            }
          }
        } else if (typeof event.data === 'object' && event.data !== null) {
          // Data is already an object
          data = event.data
        } else {
          throw new Error('Unsupported data type received')
        }
        
        if (data && data.message) {
          // Clear any previous error when successful
          
          if (setIframeErrorMessage) {
            setIframeErrorMessage('')
          }
          
          if (tokenRef.current) {
            tokenRef.current.value = data.message
          }
          
          setToken(data)
        } else if (data && data.validationError) {
          // Set error message for validation errors
          if(data.errorMessage === 'Invalid Account Number'){
            data.validationError = errorMessage.invalidCardNumber
          }

          if (setIframeErrorMessage) {
            setIframeErrorMessage(data.validationError)
          }
          throw new Error(data.validationError)
        } else if (data && data.error) {
          // Handle error property
          if (data.errorMessage === 'Invalid Account Number') {
            data.validationError = errorMessage.invalidCardNumber
          }

          if (setIframeErrorMessage) {
            setIframeErrorMessage(data.error)
          }
          throw new Error(data.error)
        }
      } catch (error) {
        console.error('CardTokenizer error:', error)
        console.error('Original event.data:', event.data)
        // Set error message for any other errors
        if (setIframeErrorMessage) {
          setIframeErrorMessage(error.message || errorMessage.somethingWentWrong)
        }
      }
    }

    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [setToken, faciltyPaymentDetails])

  const css = encodeURIComponent(`
      body{
        border: none !important;
        font-family: Rubik !important;
      }
      input, select {
        padding: 12px 16px !important;
        border: 1px solid #ccc !important;
        border-radius: 6px !important;
        margin: 7px 0px !important;
        max-width: 100% !important;
        box-sizing: border-box !important;
        font-size: 12px !important;
      }
      input[name="ccnumfield"]{
        width: 100% !important;
      }
      input::placeholder {
        font-size: 12px !important;
      }
      input:focus, select:focus {
        border: 1px solid #26a8e0 !important;
        outline: none !important;
      }
      label{
        font-size: 0.875em !important;
        font-weight: normal !important;
        color: #212529 !important;
      }
      label[for="ccexpiryfieldyear"] {
        display: inline-block !important;
        width: auto !important;
      }
      #ccexpiryfieldmonth,
      #ccexpiryfieldyear {
        width: 48% !important;
        display: inline-block !important;
        vertical-align: middle !important;
      }
      #cccvvfield{
        width: 100% !important;
      }
      @media (min-width: 401px) and (max-width: 850px) {
        input {
          font-size: 13px !important;
          padding: 12px 16px !important;
        }
        #ccexpiryfieldmonth,
        #ccexpiryfieldyear {
          width: 46% !important;
          font-size: 13px !important;
        }
      }
      @media (max-width: 400px) {
        input {
          font-size: 13px !important;
          padding: 12px 16px !important;
          }
          #ccexpiryfieldmonth,
          #ccexpiryfieldyear {
            width: 44% !important;
            font-size: 13px !important;
        }
    }
`)
  const iframeSrc = `${faciltyPaymentDetails?.fiserv_iframe_url}?${URL?.FISERV_IFRAME_FORMAT_URL}&css=${css}`

  return (
    <form id="tokenform" name="tokenform" className="token-form" style={{ width: '100%', height: '250px', position: 'relative'}}>
      <div className="token-container" width="100%">
        {!iframeLoaded ? (
          <div
            className="d-flex flex-column justify-content-center align-items-center text-center"
            style={{
              position: 'absolute',
              inset: 0,
              backgroundColor: '#fff',
              zIndex: 2,
            }}
          >
            <Circles
              height="50"
              width="50"
              color="var(--bs-primary)"
              ariaLabel="circles-loading"
              visible={true}
            />
            <p className="mt-2 mb-0">Loading secure payment form…</p>
          </div>
        ) : null}
        <iframe
          id="card_number"
          name="card_number"
          src={iframeSrc}
          frameBorder="0"
          scrolling="no"
          title="Secure Card Input"
          className="token-iframe"
          style={{ width: '100%', height: '250px', border: 'none', marginTop: 0, visibility: iframeLoaded ? 'visible' : 'hidden' }}
          onLoad={() => setIframeLoaded(true)}
        ></iframe>
      </div>

      {/* Hidden input for token */}
      <input type="hidden" id="mytoken" name="mytoken" ref={tokenRef} />
    </form>
  )
}

CardConnectTokenizer.propTypes = {
  dispatch: PropTypes.func,
  loader: PropTypes.bool,
  onSubmit: noop,
  isSubmittingForm: PropTypes.bool,
  setToken: PropTypes.func,
  faciltyPaymentDetails: PropTypes.object,
  setIframeErrorMessage: PropTypes.func,
  tokenRef: PropTypes.object
}

export default CardConnectTokenizer
